import { Common } from '@stockbit/ui';
import PropTypes from 'prop-types';
import { Title } from './styled';

const { Flex, IconWrapper, Iconmoon } = Common;

function OnBoardingTitle({ children, onClickBack }) {
  return (
    <Flex align="center" mb="30px">
      <IconWrapper onClick={onClickBack}>
        <Iconmoon className="icon-trading_back" size="23px" weight="bold" />
      </IconWrapper>
      <Title>{children}</Title>
    </Flex>
  );
}

OnBoardingTitle.propTypes = {
  children: PropTypes.node.isRequired,
  onClickBack: PropTypes.func.isRequired,
};

export default OnBoardingTitle;
